// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"TooltipWrapper_tooltip__13slZ","sidebarTooltip":"TooltipWrapper_sidebarTooltip__24NQw"};